import {
  Overlay,
  OverlayOptions,
  OverlayPayloadByOverlayType,
  OverlayType
} from "shared/context/overlay/types"
import { useOverlayActions } from "shared/context/overlay/useOverlayActions"
import { useEvent } from "shared/lib/useEvent"
import { useOverlays } from "shared/lib/useOverlays"

export function useOverlay<T extends OverlayType>(type: T) {
  const { currentOverlay, overlays } = useOverlays()

  const actions = useOverlayActions()

  const openOverlay = useEvent(
    (payload: OverlayPayloadByOverlayType<T>, options?: OverlayOptions) => {
      actions.openOverlay({
        overlay: { type, payload, options } as Overlay
      })
    }
  )

  return {
    currentOverlay,
    // Anywhere in the stack. isTopmost is the narrower "nothing is above me".
    isOpen: overlays.some(overlay => overlay.type === type),
    isTopmost: currentOverlay?.type === type,
    openOverlay
  }
}
